export enum IndividualGoalPriorityTypes {
    NotSelected = 0,
    High = 1,
    Medium = 2,
    Low = 3
}
